module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-01-m.429f0d37cc3534f696690b8740819fad.png";